/**
 * Tiny classname concatenator. Filters out falsy values so callers can
 * write `cn('base', condition && 'extra', className)` without nesting
 * ternaries.
 */
export function cn(
  ...args: Array<string | number | false | null | undefined>
): string {
  let out = '';
  for (const arg of args) {
    if (!arg && arg !== 0) continue;
    if (out) out += ' ';
    out += String(arg);
  }
  return out;
}
